import * as DOMUtils from "@/utils/dom";
import * as ObjectUtils from "@/utils/object";

export const setPageIcon = (to:any, from:any, next:any) => {
	let icon = ObjectUtils.getDeepProperty(to, "meta.icon", null);
	DOMUtils.setFavIcon(icon || "envralys-tab");
	next();
};